























import type { Signature, Source } from '@/data';
import CanvasSource3D from '@/vuejs/components/canvas-sources/CanvasSource3D.vue';
import CanvasSourceGrid from '@/vuejs/components/canvas-sources/CanvasSourceGrid.vue';
import CanvasSourceScore from '@/vuejs/components/canvas-sources/CanvasSourceScore.vue';
import { defineComponent } from 'vue';
import { SourceType, type ImageLikeSource } from '@/data/Source';
import type Tab from '@/data/Tab';
import CanvasSourceTab from './CanvasSourceTab.vue';

export default defineComponent({
  name: 'CanvasSourceBase',
  components: {
    CanvasSource3D, CanvasSourceScore, CanvasSourceGrid, CanvasSourceTab,
  },
  props: {
    source: {
      type: Object as () => ImageLikeSource,
      required: true,
    },
    signature: {
      type: Object as () => Signature,
      required: true,
    },
  },
  computed: {
    tabSource() : Tab | undefined {
      return (this.source.type === SourceType.Tab || this.source.type === SourceType.TabLinear)
        ? this.source as Tab : undefined;
    },
    imageSource() : Source | undefined {
      return (this.source.type === SourceType.Tab || this.source.type === SourceType.TabLinear)
        ? undefined : this.source as Source;
    },

  },

});
